import '../../confirmation-page.scss';
import './index.scss';
import _ from 'underscore';
import React, { PropTypes } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { startCloningOperation } from '../../../js/actions/cloningWorkflowActionCreators';
import { finishCloningWorkflow } from '../../../js/actions/workflowActionCreators';
import { updateStatuses } from '../../../js/statuses';
import { isUndefinedNullOrEmpty } from '../../../js/utils';
import { hasValidLicence } from '../../../js/projections/licence';
import { reliablyHandleAsyncFormSubmit } from '../../common/formUtils';
import { InputFieldWithValidation } from '../../common/FormComponents';
import LoaderWithText from '../../common/LoaderWithText';
import FormErrorNotification from '../../common/FormErrorNotification';
import BackLink from '../../common/BackLink';
import { setTourEnabled } from '../../../js/actions/tourActionCreators';
import Joyride from 'react-joyride';
import { JoyrideStepStyle } from '../../common/Joyride/steps';

const steps = [{
    title: 'Give your clone a name',
    text: 'Before creating your clone you must give it a name. You can also check the settings you have chosen so far.', // supports html tags
    selector: '.operation-overview',
    position: 'left',
    type: 'hover',
    isFixed: true,
    style: JoyrideStepStyle,
}];

const validate = (values) => {
    const errors = {};

    if (isUndefinedNullOrEmpty(values.databaseName)) {
        errors.databaseName = 'Specify a database name';
    }
    else if (values.databaseName.indexOf('[') > -1 || values.databaseName.indexOf(']') > -1) {
        errors.databaseName = 'The database name should not contain square brackets'; 
        //We strip out square brackets in the back-end to easily avoid SQL injection, so should avoid them being entered where possible
    }

    if (!isUndefinedNullOrEmpty(values.databaseName) && values.databaseName.length > 128) {
        errors.databaseName = 'Clone database name cannot have more than 128 characters';
    }

    return errors;
};

let CloneCreationConfirmationPage = React.createClass({
    propTypes: {
        canCreate: PropTypes.bool.isRequired,
        selectedImage: PropTypes.object.isRequired,
        destination: PropTypes.object.isRequired,
        status: PropTypes.oneOf(_(updateStatuses).values()).isRequired,
        isCloneCreationCompleted: PropTypes.bool.isRequired,
        startOperation: PropTypes.func.isRequired,
        setCloneCreationAsFinished: PropTypes.func.isRequired,
        handleSubmit: PropTypes.func.isRequired
    },
    startOperation: function(data) {
        return reliablyHandleAsyncFormSubmit(() => {
            const { selectedImage, destination } = this.props;
            return this.props.startOperation({
                name: data.databaseName,
                imageId: selectedImage.id,
                locationId: destination.id
            });
        });
    },
    componentWillReceiveProps: function (nextProps) {
        const { cloneCreation, isCloneCreationCompleted } = nextProps;
        if (isCloneCreationCompleted) {
            browserHistory.push('/dashboard/images/' + cloneCreation.operation.imageId);
        }
    },
    componentWillUnmount: function() {
        const { isCloneCreationCompleted, setCloneCreationAsFinished } = this.props;
        if(isCloneCreationCompleted) {
            setCloneCreationAsFinished();
        }
    },
    tourCallback(value) {
        if (value && value.type === 'finished' && value.isTourSkipped) {
            this.props.setTourEnabled('dashboard', false);
            ga('send', 'event', {
                    eventCategory: 'tour',
                    eventAction: 'skippedCloneConfirmationn',
                    eventLabel: 'Skipped tour on clone confirmation page'
                });
        }
        if (value && value.type === 'finished' && !value.isTourSkipped) {
            ga('send', 'event', {
                    eventCategory: 'tour',
                    eventAction: 'finishedCloneConfirmation',
                    eventLabel: 'End of clone confirmation tour'
                });
        }
    },
    render: function () {
        const { selectedImage, destination, status, handleSubmit, canCreate, error, valid, pristine, } = this.props;
        const hasCloneCreationStarted = status !== updateStatuses.initial;
        const hasCloneCreationFailed = status === updateStatuses.failure;
        const isProcessing = hasCloneCreationStarted && !hasCloneCreationFailed;

        return <form onSubmit={handleSubmit(this.startOperation)}>
            <div className="content-container">
                <Joyride ref="joyride" run={this.props.tourEnabled} autoStart={true} showSkipButton={true} type="continuous" steps={steps} callback={this.tourCallback} debug="true" locale={{ last: 'Next', next: 'Next', skip: 'Skip', back: 'Back' }}/>
                <div className="form-container">
                <FormErrorNotification error={error} />
                
                <BackLink />
                <h1>Review and create clone</h1>
                <div className="clone-review operation-overview">
                    <div className="confirmation-content pure-g">
                        <div className="confirm-row pure-u-1-1">
                            <div className="pure-u-1-1"><h4>Image</h4></div>
                            <div className="imageName pure-u-3-4">{selectedImage.name}</div>
                        </div>
                        <div className="confirm-row pure-u-1-1">
                            <div className="pure-u-1-1"><h4>Server Instance</h4></div>
                            <div className="serverName pure-u-3-4">{destination.friendlyName}</div>
                        </div>
                        <div className="confirm-row pure-u-1-1">
                            <div className="pure-u-1-1"><h4>Clone Name</h4></div>
                            <div className="cloneName pure-u-3-4">
                                <Field className="pure-input-1-2" name="databaseName" type="text" autoFocus
                                    placeholder="e.g Sales_Clone" component={InputFieldWithValidation} />
                            </div>
                        </div>
                    </div>
                </div>

                    <div>
                        {isProcessing && <LoaderWithText loadingText="Creating" />}
                        <div className="button-holder">
                            <button type="submit" className="button button--primary header-button" disabled={isProcessing || !valid || pristine || !canCreate}>Create Clone</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>;
    }
});

const mapStateToProps = (state) => {
    const cloneCreationDetails = state.app.cloneCreation;
    const instance = state.sqlServerInstances.value.get(cloneCreationDetails.destination.id);

    return {
        canCreate: hasValidLicence(state),
        status: cloneCreationDetails.operation.status,
        selectedImage: state.images.value.get(cloneCreationDetails.source),
        cloneCreation: cloneCreationDetails,
        destination: {
            id: cloneCreationDetails.destination.id,
            friendlyName: instance.server + '\\' + instance.instance,
            databaseName: cloneCreationDetails.destination.databaseName
        },
        isCloneCreationCompleted: !isUndefinedNullOrEmpty(cloneCreationDetails) &&
            !isUndefinedNullOrEmpty(cloneCreationDetails.operation) &&
            !isUndefinedNullOrEmpty(cloneCreationDetails.operation.imageId),
            tourEnabled: state.tour.dashboard
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        startOperation: (cloneDetails) => {
            return dispatch(startCloningOperation(cloneDetails));
        },
        setCloneCreationAsFinished: () => {
            dispatch(finishCloningWorkflow());
        },
        setTourEnabled: (tour, enabled) => {
            dispatch(setTourEnabled(tour, enabled));
        }
    };
};

CloneCreationConfirmationPage = connect(mapStateToProps, mapDispatchToProps)(
    reduxForm({ form: 'CloneCreationConfirmationForm', validate })(CloneCreationConfirmationPage)
);

CloneCreationConfirmationPage.title = 'Review';

export default connect(mapStateToProps, mapDispatchToProps)(CloneCreationConfirmationPage);



// WEBPACK FOOTER //
// ./src/components/cloning/CloneCreationConfirmationPage/index.jsx